import {Listview} from "../../listview";
import ko from "knockout";
import {customFetch as fetch} from "../../fetch";
import moment from "moment/moment";
import h from "virtual-dom/h";
import { closePopups, openPopup } from '../../init';

export class ApplicationInformations {
    items: KnockoutObservableArray<ApplicationInformation>;
    showActive: KnockoutObservable<boolean>;
    type: string;
    listview: Listview;

    viewTitle: KnockoutObservable<string>;
    viewStart: KnockoutObservable<string>;
    viewEnd: KnockoutObservable<string>;
    viewContent: KnockoutObservable<string>;
    constructor(type: string) {
        this.items = ko.observableArray<ApplicationInformation>();
        this.showActive = ko.observable<boolean>(false);
        this.type = type;
        this.loadIssues();

        this.viewTitle = ko.observable<string>('');
        this.viewStart = ko.observable<string>('');
        this.viewEnd = ko.observable<string>('');
        this.viewContent = ko.observable<string>('');
        
        this.listview = new Listview({
            rootElementId: 'applicationInformations',
            pagerOptions: {pagerElementId: 'applicationInformations-pager'},
            getItems: async () => {
                const response = await fetch(`/ApplicationInformation/Get${this.type}`);
                if (response.ok) {
                    return response.data;
                }

                return [];
            },
            columns: [
                {
                    position: 1,
                    header: 'Title',
                    property: 'title'
                },
                {
                    position: 2,
                    header: 'Start',
                    property: 'start',
                    render: (item: any) => moment(item.start).format('DD-MM-YYYY HH:mm')
                },
                {
                    position: 3,
                    header: 'Eind',
                    property: 'end',
                    render: (item: any) => item.end ? moment(item.end).format('DD-MM-YYYY HH:mm') : ''
                },
                {
                    position: 4,
                    header: 'Actief',
                    property: 'active',
                    render: (item: any) => item.active ? h('i', {className: 'fa fa-check'}, []) : h('i', {className: 'fa fa-times'}, [])
                }
            ],
            postRender: () => {
                Array.from(document.querySelectorAll('#applicationInformations tr td:not(:last-child)')).forEach((td) => {
                    const listviewItem = JSON.parse(td.parentElement!.dataset.listviewItem!);

                    td.addEventListener('click', () => {
                        this.openViewPopup(listviewItem);
                    });
                });
            }
        });
        this.listview.load();
    }

    openViewPopup(item: any) {
        this.viewTitle(item.title);
        this.viewStart(moment(item.start).format('DD-MM-YYYY HH:mm'));
        this.viewEnd(moment(item.end).format('DD-MM-YYYY HH:mm'));
        this.viewContent(item.content);
        openPopup('view-content');
    }
    
    closePopup(){
        closePopups()
    }

    async loadIssues() {
        let response = await fetch(`/ApplicationInformation/Active${this.type}`);
        if (response.data !== undefined && response.data.length > 0) {
            this.items(response.data.map((d: any) => new ApplicationInformation(d)));
            this.showActive(true);
        } else {
            this.showActive(false);
        }
    }
}

export class ApplicationInformation {
    id: KnockoutObservable<string>;
    title: KnockoutObservable<string>;
    content: KnockoutObservable<string>;
    type: KnockoutObservable<string>;
    start: KnockoutObservable<string>;
    end: KnockoutObservable<string>;
    active: KnockoutObservable<boolean>;

    constructor(item: any) {
        this.id = ko.observable<string>(item.id);
        this.title = ko.observable<string>(item.title);
        this.content = ko.observable<string>(item.content);
        this.type = ko.observable(this.getType(item.type));
        this.start = ko.observable<string>(moment(item.start).format('DD-MM-yyyy'));
        this.end = ko.observable<string>(item.end === null ? '' : moment(item.end).format('DD-MM-yyyy'));
        this.active = ko.observable<boolean>(item.active);
    }

    private getType(type: number): string {
        switch (type) {
            case 1:
                return 'Mededeling';
            case 2:
                return 'Release note';
            default:
                return 'Onbekend';
        }
    }
}
